module.exports = __webpack_public_path__ + "img/pg.b91f3974.png";